module.exports = __webpack_public_path__ + "img/SKMJ_protect2.85796ec3.png";